module.exports = __webpack_public_path__ + "img/InvCompany.0cbea057.jpg";